(function () {
  "use strict";

  angular
    .module('trainerWebApp.directives')
    .directive('mfEditCoursesAndSeriesSidebar', mfEditCoursesAndSeriesSidebar);

  function mfEditCoursesAndSeriesSidebar() {

    return {
      restrict:'A',
      link:function ($scope, iElement, iAttrs) {
        var sidebarBorder = iElement.parents('.user-sidebar-border')[0];

        var  KEY = {
          TAB: 9,
          ENTER: 13
        };

        var checkHighlightedValue = false;

        var KEY = {
          TAB: 9,
          ENTER: 13,
          ESC: 27,
          SPACE: 32,
          LEFT: 37,
          UP: 38,
          RIGHT: 39,
          DOWN: 40,
          SHIFT: 16,
          CTRL: 17,
          ALT: 18,
          PAGE_UP: 33,
          PAGE_DOWN: 34,
          HOME: 36,
          END: 35,
          BACKSPACE: 8,
          DELETE: 46,
          isArrow: function (k) {
            k = k.which ? k.which : k;
            switch (k) {
              case KEY.LEFT:
              case KEY.RIGHT:
              case KEY.UP:
              case KEY.DOWN:
                return true;
            }
            return false;
          }
        };

        setup('course');
        if ($scope.hasSeriesFeature)
          setup('series');

        function setup(type) {
          var typePlural = type;
          if (type != 'series')
            typePlural = type + 's';
          var typePluralCap = typePlural.charAt(0).toUpperCase() + typePlural.slice(1);
          var select = iElement.find('#input' + typePluralCap + 'Multiple');
          var opts = $scope['select' + typePluralCap + 'Options'];

          opts.formatResult = function(object, container, query) {
            var term = $.trim(query.term || "");
            var html = '<div title="' + _.escape(object.text) + '">';

            if (object.label && !object.hideLabelInDropDown)
              html = html + '<span>' + object.label + ': </span>';
            var startOfCriteriaInResult = _.escape(object.text.toLowerCase().indexOf(term.toLowerCase()));

            if (startOfCriteriaInResult > 0)
              html = html + '<span>' + _.escape(object.text.substr(0, startOfCriteriaInResult)) + '</span>';
            else
              startOfCriteriaInResult = 0;

            html = html + '<span class="select2-match">' + _.escape(object.text.substr(startOfCriteriaInResult, term.length)) + '</span>';
            if (object.text.length > startOfCriteriaInResult + term.length) {
              var startOfRestOfResult = startOfCriteriaInResult + term.length;
              html = html + '<span>' + _.escape(object.text.substr(startOfRestOfResult, object.text.length - startOfRestOfResult)) + '</span>';
            }

            html = html + '</div>';
            container[0].innerHTML = html;
          };

          select.select2(opts);
          var select2 = select.select2('container').data('select2');

          select2.search.on('keydown', function (e) {
            if (!KEY.isArrow(e)) {
              checkHighlightedValue = true;
            }
          });

          select2.search.on('keyup', function (e) {
            checkHighlightedValue = false;
          });

          select.bind("select2-selecting", function (event) {
            $scope.$apply(function () {
              $scope.addCourse(event.object, type);
            });
            clearInput();
            event.preventDefault();
          });

          function clearInput(){
            var searchInput = iElement.find('.select2-input');
            select.select2('close');
            searchInput.val('');
            searchInput.removeClass("select2-default");
            select.select2('open');
          }

          select.bind('select2-open', function (event) {
            $('.select2-dropdown-size-hack').removeClass('select2-dropdown-size-hack');
            // Triggering a scroll event on the scrollable div fixes positioning of the dropdown when it opens
            // above the input.
            $(sidebarBorder).trigger('scroll');
          });

          $scope.forceCloseDropDown = function () {
            select.select2('close');
          };

          $scope.$on('$destroy', function(){
            $scope.forceCloseDropDown();
          });
        }
      }
    }
  }

})();
